<template>
    <div class="kgk-user-certificates">
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
        <div v-else>
            <CertificateList :certificates="certificates.user" />

            <template v-if="certificates.team.length">
                <h3 style="font-size:14px;margin-top:20px;margin-bottom:8px;">Team-Urkunden</h3>
                <CertificateList :certificates="certificates.team" />
            </template>

            <template v-if="certificates.company.length">
                <h3 style="font-size:14px;margin-top:20px;margin-bottom:8px;">Firmen-Urkunden</h3>
                <CertificateList :certificates="certificates.company" />
            </template>
        </div>
        <div class="spacer-small"></div>
    </div>
</template>

<script>
import user from '../../api/user';
import CertificateList from './CertificateList';

export default {
    name: 'MyCertificates',
    components: {
        CertificateList,
    },
    data() {
        return {
            certificates: { user: [], team: [], company: [] },
            loading: false,
            error: null,
        }
    },
    methods: {
        loadCertificates() {
            this.loading = true;

            user.getCertificates(
                this,
                data => {
                    this.certificates = data.certificates;
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        },
    },
    mounted() {
        this.loadCertificates();
    }
}
</script>
